import { render, staticRenderFns } from "./DirectDispatch.html?vue&type=template&id=3439a3fd&external"
import script from "./DirectDispatch.js?vue&type=script&lang=js&external"
export * from "./DirectDispatch.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports